"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleFinalAndAddendaV4 = exports.radV4 = exports.basicCaseRunV2 = exports.noDisplayedCodes = exports.duplicateArtifacts = exports.multipleAutomated = exports.onlyManual = exports.manualAndAutomated = exports.errorCase = exports.noProcessInstances = exports.nullProcessStatus = exports.predictionInProgress = exports.waitingForData = exports.inProgressWaitingCase = exports.inProgressCase = exports.cancelled = exports.didNotCode = exports.updatedManual = exports.dataCollected = exports.atCoder = exports.dormantAutomatedCase = exports.dormantUnautomatedCase = exports.sentToCACPreventSending = exports.failedClaims = exports.failedCCI = exports.noSchedulingDept = exports.sentToCAC = exports.radFootCase = exports.nullRules = exports.missingData = exports.automatedCasePreventBilling = exports.noPrimaryProcess = exports.multipleFinalAndAddenda = exports.caseWithAddendum = exports.multipleCaseRuns = exports.autoActiveCase = exports.autoLiveCase = exports.autoParallelCase = exports.passedCCIEdits = exports.failedCCIEdits = exports.passedClaimsEdits = exports.failedClaimsEdits = exports.autoTestingCase = exports.automatedCase = exports.mammo = void 0;
var enums_1 = require("../enums");
var artifacts_1 = require("./artifacts");
var notes_1 = require("./notes");
var mammo_1 = require("./cases/mammo");
var rules_and_reasons_1 = require("./rules-and-reasons");
__exportStar(require("./multiple-addendum"), exports);
exports.mammo = mammo_1.mammo;
var processedArtifact = {
    type: "PROCESSED",
    artifact_id: 10344,
    identifier: null,
    procedures: {
        evidence: [],
        automate: true,
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c47",
        codes: [
            {
                procedure_code: "73030",
                units: 1.0,
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c42",
                evidence: [
                    {
                        feature: {
                            uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                            type: "ngram",
                            ngram: "No endoleaks are detected",
                            slop: 1,
                            in_order: true,
                            display: true,
                            field: "raw_body",
                            spans: [
                                {
                                    start: 812,
                                    end: 837,
                                    uuid: "cce97bb3-9d74-4d1f-b0e3-095c583ddc3",
                                    document_id: 234325,
                                    content: "No endoleaks are detected ngram",
                                    level: "ngram"
                                },
                                {
                                    start: 812,
                                    end: 837,
                                    uuid: "cce97bb3-9d74-4d1f-b0e3-095dd583ddc3",
                                    document_id: 234325,
                                    content: "No endoleaks are detected sentence",
                                    level: "sentence"
                                }
                            ]
                        },
                        type: "Ngram",
                        score: 1.8524357683146013
                    }
                ],
                modifiers: {
                    evidence: [],
                    automate: true,
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca1",
                            modifier_code: "LT",
                            automate: true,
                            confidence: 0.99,
                            evidence: []
                        }
                    ]
                },
                diagnoses: {
                    evidence: [],
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0ca2",
                            diagnosis_code: "M19.012",
                            confidence: 0.59,
                            automate: true,
                            evidence: [
                                {
                                    details: {
                                        feature: {
                                            type: "ngram",
                                            ngram: "chest pain",
                                            field: "raw_reasonforvisit",
                                            slop: 2,
                                            in_order: true
                                        },
                                        score: 0.21478298151125555,
                                        type: "Unknown"
                                    },
                                    type: "Unknown"
                                },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c83",
                                        type: "categorical",
                                        category: "Spine",
                                        field: "body_region"
                                    },
                                    type: "Categorical",
                                    score: 0.04377880184331798
                                },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c66",
                                        type: "categorical",
                                        category: "PET",
                                        field: "procedure_category"
                                    },
                                    type: "Categorical",
                                    score: 0.23316912972085382
                                },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c55",
                                        type: "ngram",
                                        ngram: "dome of the diaphragm",
                                        slop: 1,
                                        in_order: true,
                                        display: true,
                                        field: "raw_body",
                                        spans: [
                                            {
                                                start: 0,
                                                end: 49,
                                                content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                                                uuid: "7797bb3-9d74-4d1f-b0e3-095ee583ddc3",
                                                document_id: 234325,
                                                level: "ngram"
                                            },
                                            {
                                                start: 0,
                                                end: 49,
                                                content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                                                uuid: "7797bb3-9d74-4d1f-b0e3-095ff583ddc3",
                                                document_id: 234325,
                                                level: "sentence"
                                            }
                                        ]
                                    },
                                    type: "Ngram",
                                    score: 1.8524357683146013
                                },
                                {
                                    feature: {
                                        uuid: "blah",
                                        type: "ngram",
                                        ngram: "dome of the diaphragm",
                                        slop: 1,
                                        in_order: true,
                                        display: true,
                                        field: "raw_reasonforvisit",
                                        spans: []
                                    },
                                    type: "Ngram",
                                    score: 1.8524357683146013
                                }
                            ]
                        },
                        {
                            confidence: 0.9900000000000001,
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c41",
                            diagnosis_code: "R60.0",
                            automate: true,
                            evidence: [
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c38",
                                        type: "prior"
                                    },
                                    type: "Prior",
                                    score: -1.054492930037871e-5
                                },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-35688768888",
                                        type: "categorical",
                                        category: "OB Ultrasound",
                                        field: "procedure_type"
                                    },
                                    type: "Categorical",
                                    score: 0.019858258340373337
                                },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568234234234",
                                        type: "ngram",
                                        ngram: "us soft",
                                        field: "exam_type",
                                        slop: 0,
                                        in_order: true
                                    },
                                    type: "Ngram",
                                    score: 0.007440717499160134
                                },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c40",
                                        type: "ngram",
                                        ngram: "dome of the diaphragm",
                                        slop: 1,
                                        in_order: true,
                                        display: true,
                                        field: "raw_body",
                                        spans: [
                                            {
                                                start: 0,
                                                end: 49,
                                                content: "Mildly increased uptake associated with the posterior aspect of the posterior gastric wall, not entirely specific but without definite CT correlate but could be correlated with endoscopy given the lymphoma variant. ",
                                                uuid: "7797bb3-9d74-4d1f-b0e3-095gg583ddc3",
                                                document_id: 234325,
                                                level: "ngram"
                                            },
                                            {
                                                start: 0,
                                                end: 49,
                                                content: "Helically acquired axial images from the dome of the diaphragm",
                                                uuid: "7797bb3-9d74-4d1f-b0e3-095hh583ddc3",
                                                document_id: 234325,
                                                level: "sentence"
                                            },
                                            {
                                                start: 118,
                                                end: 214,
                                                content: "Helically acquired axial images from the dome of the diaphragm",
                                                document_id: 234325,
                                                level: "ngram",
                                                uuid: "7797bb3-9d74-4d1f-b0e3-095bb583ddc7"
                                            },
                                            {
                                                start: 118,
                                                end: 214,
                                                content: "Helically acquired axial images from the dome of the diaphragm",
                                                document_id: 234325,
                                                level: "sentence",
                                                uuid: "7797bb3-9d74-4d1f-b0e3-095bb583ddc9"
                                            }
                                        ]
                                    },
                                    type: "Ngram",
                                    score: 1.8524357683146013
                                },
                                {
                                    feature: {
                                        uuid: "blah",
                                        type: "ngram",
                                        ngram: "dome of the diaphragm",
                                        slop: 1,
                                        in_order: true,
                                        display: true,
                                        field: "raw_reasonforvisit",
                                        spans: []
                                    },
                                    type: "Ngram",
                                    score: 1.8524357683146013
                                },
                                // {
                                //   feature: {
                                //     uuid: 'c7cc349b-b62a-4951-8da8-3568876e0c43',
                                //     type: 'ngram',
                                //     field: 'raw_reasonforvisit',
                                //     ngram: 'fever, cough',
                                //     slop: 1,
                                //     in_order: true
                                //   },
                                //   type: 'Ngram',
                                //   score: 1.8510916053185522
                                // },
                                {
                                    feature: {
                                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c44",
                                        type: "ngram",
                                        field: "body_region",
                                        ngram: "CT ABD/PELVIS",
                                        slop: 1,
                                        in_order: true
                                    },
                                    type: "Ngram",
                                    score: -1.8510916053185522
                                }
                            ]
                        }
                    ]
                }
            },
            {
                procedure_code: "77067",
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-356887688c46",
                units: 0.0,
                modifiers: {
                    evidence: [],
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-7778888e0ca1",
                            modifier_code: "LT",
                            confidence: 0.99,
                            automate: true,
                            evidence: []
                        }
                    ]
                },
                diagnoses: {
                    evidence: [],
                    codes: []
                }
            }
        ]
    },
    modifiers: {
        evidence: [],
        codes: []
    },
    diagnoses: {
        evidence: [],
        codes: [
            {
                diagnosis_code: "S49.92XA",
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c45",
                automate: false,
                confidence: 0.03,
                evidence: [
                    {
                        feature: {
                            uuid: "hhh5dc26-210e-4bdc-afae-20758be67410",
                            type: "ngram",
                            ngram: "3D IMAGES WITH REFORMATTING AND POST-PROCESSING RECONSTRUCTIONS WERE PERFORMED AND INTERPRETED",
                            slop: 1,
                            in_order: true,
                            display: true,
                            field: "raw_body",
                            spans: [
                                {
                                    start: 432,
                                    end: 528,
                                    uuid: "efe97bb3-9d74-4d1f-b0e3-095ii583ddc3",
                                    document_id: 234325,
                                    content: "3D IMAGES WITH REFORMATTING AND POST-PROCESSING RECONSTRUCTIONS WERE PERFORMED AND INTERPRETED",
                                    level: "ngram"
                                },
                                {
                                    start: 432,
                                    end: 528,
                                    uuid: "ehe97bb3-9d74-4d1f-b0e3-095jj583ddc3",
                                    document_id: 234325,
                                    content: "3D IMAGES WITH REFORMATTING AND POST-PROCESSING RECONSTRUCTIONS WERE PERFORMED AND INTERPRETED",
                                    level: "sentence"
                                }
                            ]
                        },
                        type: "Ngram",
                        score: 1.8524357683146013
                    }
                ]
            }
        ]
    }
};
var predictionArtifact = __assign(__assign({}, JSON.parse(JSON.stringify(processedArtifact))), { artifact_id: 55523, type: enums_1.CaseArtifactTypes.PREDICTION });
predictionArtifact.procedures.codes[0].evidence = [];
predictionArtifact.diagnoses.codes = __spreadArray([], __read(predictionArtifact.procedures.codes[0].diagnoses.codes), false);
predictionArtifact.procedures.codes[0].diagnoses.codes = [];
predictionArtifact.modifiers.codes = __spreadArray(__spreadArray([], __read(predictionArtifact.procedures.codes[0].modifiers.codes), false), __read(predictionArtifact.procedures.codes[1].modifiers.codes), false);
predictionArtifact.procedures.codes[0].modifiers.codes = [];
predictionArtifact.procedures.codes[1].modifiers.codes = [];
var _baseCaseRun = {
    case_id: 10,
    case_status: "Done",
    process_instance_id: 10,
    process_status: "Predicted",
    facility: "HFM",
    process_instance_guid: "some guid",
    tenant_insurance_payer_number: "",
    case_uid: "123",
    cci_edit_indicator: null,
    cci_editor_issues: null,
    claims_edit_indicator: null,
    claims_edit_enabled_indicator: null,
    claims_editor_issues: null,
    claims_editor_payer_id: "053",
    claims_editor_payer_name: null,
    phase: enums_1.CustomerPhase.LIVE,
    run_type: "prediction",
    source_type: "HL7",
    service_line: "Radiology",
    tenant_code: "MGH",
    tenant_name: "Massachusetts General Hospital",
    health_system_code: "PHS",
    patient_id: "2132",
    patient_name: "Jingleheimer Schmidt, Johanna Jacobina",
    date_of_birth: "1988-08-12",
    patient_gender: "F",
    primary_process_indicator: true,
    patient_identifier: {
        number: "800480",
        issuer: "MEEI"
    },
    visit_number: {
        number: "2000934592",
        issuer: "CMX"
    },
    account_number: null,
    patient_class: "OUTPATIENT",
    patient_type: null,
    reason_for_visit: "fever, cough",
    primary_insurance: "MEDICARE PART A & B",
    primary_insurance_category: "",
    encounter_identifier: {
        number: "800480-20200318-FAMMD",
        issuer: "CMX",
        type: "ENCOUNTER_NUMBER"
    },
    exam_description: "BI MAMMOGRAM SCREENING WITH TOMOSYNTHESIS WITH CAD (BILATERAL)",
    point_of_care: null,
    place_of_service: "CMX Radiology-500 Main St",
    order_control: null,
    order_number: {
        number: "3246035",
        issuer: "EPC"
    },
    order_placer_number: {
        number: "3246035",
        issuer: "EPC"
    },
    order_filler_number: {
        number: "E86056",
        issuer: "EPC"
    },
    ordering_provider_name: "GREY MD, MEREDITH",
    ordering_provider_specialty: null,
    ordering_provider_number: {
        number: "768796011",
        issuer: "EPIC"
    },
    primary_clinical_identifier: {
        number: "E86056",
        issuer: "EPC"
    },
    division: null,
    exam_code: "MG.BI.SCTMCD/B",
    body_region: null,
    procedure_type: "OB Ultrasound",
    procedure_type_category: null,
    date_of_service: "2020-03-18",
    exam_date: "2020-03-17",
    result_status: "F",
    billing_location: "Outpatient",
    billing_area: "CMX IMAGING",
    billing_provider_specialty: "Radiology",
    billing_provider_name: "DUNHAM MD,SALLY V",
    billing_provider_number: {
        number: "1750589495",
        issuer: "NPI"
    },
    billing_provider_assistant_name: null,
    billing_provider_assistant_number: null,
    scheduling_department: null,
    placer_field_2: null,
    work_queue_name: null,
    mappings: [],
    artifacts: [
        processedArtifact,
        predictionArtifact,
        {
            type: "CLINICAL",
            artifact_id: 77234,
            identifier: "Yadda",
            procedures: {
                evidence: [],
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c48",
                codes: [
                    {
                        procedure_code: "77067",
                        automate: true,
                        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c46",
                        units: 0.0,
                        modifiers: {
                            evidence: [],
                            codes: []
                        },
                        diagnoses: {
                            evidence: [],
                            codes: []
                        }
                    }
                ]
            },
            modifiers: {
                evidence: [],
                codes: []
            },
            diagnoses: {
                evidence: [],
                codes: []
            }
        }
    ],
    notes: __spreadArray([], __read(notes_1.notes), false),
    case_created_datetime: "2020-03-20 1923",
    process_instance_created_datetime: "2020-03-20 1923",
    exclusion_datetime: null,
    prediction_start_datetime: null,
    added_to_batch_datetime: null,
    response_from_batch_datetime: null,
    prediction_end_datetime: null,
    automation_decision_datetime: null,
    send_to_coder_datetime: null,
    received_from_coder_datetime: null,
    send_to_billing_datetime: null,
    process_instance_completed_datetime: null,
    case_completed_datetime: null,
    patient_age: null,
    prevent_billing_indicator: true,
    prevent_send_to_coder_indicator: null,
    automated_indicator: false,
    route_to_predict: true,
    route_to_billing: true,
    route_to_qa: false,
    rules: null,
    route_to_coder: null,
    pre_prediction_process_reason: null,
    post_prediction_process_reason: null,
    automate_decision_reason: null,
    termination_indicator: null,
    study_indicator: false,
    automation_eligible: null,
    process: {
        tasks: [
            {
                task_id: "StartDecoratorRulesSubprocess",
                task_type: "startEvent",
                task_name: "Start decoration",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CopyCaseDataToProcessInstanceServiceTask",
                task_type: "serviceTask",
                task_name: "Copy case data to process Instance",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "UpdateCaseStatusToInProcessServiceTask",
                task_type: "serviceTask",
                task_name: "Update case status to 'In Process'",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StartPrePredictionRulesSubprocess",
                task_type: "startEvent",
                task_name: "Start pre-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RetrieveCaseNotesServiceTask",
                task_type: "serviceTask",
                task_name: "Retrieve notes",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "PostPredictionSaveCaseServiceTask",
                task_type: "serviceTask",
                task_name: "Save case",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StartPredictionSubprocess",
                task_type: "startEvent",
                task_name: "Start prediction",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "SaveCaseServiceTask",
                task_type: "serviceTask",
                task_name: "Save case",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "EndRoutingSubprocess",
                task_type: "terminateEndEvent",
                task_name: "End routing",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "EndDecoratorRulesSubprocess",
                task_type: "terminateEndEvent",
                task_name: "End decoration",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "ExitRoutingInclusiveGateway",
                task_type: "inclusiveGateway",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RouteToCACSubprocess",
                task_type: "callActivity",
                task_name: "Route to CAC",
                incoming_transitions: "",
                task_iterations: 1,
                task_end_timestamp: "",
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "IsAllRequiredCaseDataAvailableExclusiveGateway",
                task_type: "exclusiveGateway",
                task_name: "Is all required case data available?",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StartSendToCACSubprocess",
                task_type: "startEvent",
                task_name: "Start send to CAC",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunPostPredictionRulesSubprocess",
                task_type: "callActivity",
                task_name: "Run post-prediction rules",
                incoming_transitions: "",
                task_iterations: 1,
                task_end_timestamp: "",
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StartRoutingSubprocess",
                task_type: "startEvent",
                task_name: "Start routing",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RetrieveAndSaveExamCodeMapServiceTask",
                task_type: "serviceTask",
                task_name: "Retrieve and save exam code map",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RecordReasonServiceTask",
                task_type: "serviceTask",
                task_name: "Record reason",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "UpdateCaseStatusToDone",
                task_type: "serviceTask",
                task_name: "Update case status to 'Done'",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "UpdateProcessInstanceToDataCollectedServiceTask",
                task_type: "serviceTask",
                task_name: "Update process instance to 'data collected'",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "IsAllRequiredProcessInstanceDataAvailableExclusiveGateway",
                task_type: "exclusiveGateway",
                task_name: "Is all requried process instance data available?",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CheckProcessInstanceRequiredFieldsServiceTask",
                task_type: "serviceTask",
                task_name: "Check process instance required fields",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StorePredictedArtifactsServiceTask",
                task_type: "serviceTask",
                task_name: "Store predicted artifacts",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CheckRouteToBillingExclusiveGateway",
                task_type: "exclusiveGateway",
                task_name: "Selected destination?",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "EndPredictionSubprocess",
                task_type: "terminateEndEvent",
                task_name: "End prediction",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunTenantPostPredictionRulesServiceTask",
                task_type: "businessRuleTask",
                task_name: "Run tenant post-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "UpdateProcessInstanceStatustoPredictedServiceTask",
                task_type: "serviceTask",
                task_name: "Update process instance status to 'Predicted'",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "UpdateProcessInstanceStatusToStartedServiceTask",
                task_type: "serviceTask",
                task_name: "Update process Instance status to 'Started'",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunTenantPrePredictionRulesServiceTask",
                task_type: "businessRuleTask",
                task_name: "Run tenant pre-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunPrePredictionRulesSubprocess",
                task_type: "callActivity",
                task_name: "Run pre-prediction rules",
                incoming_transitions: "",
                task_iterations: 1,
                task_end_timestamp: "",
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "UpdateCaseStatusToCaseDataCollectedServiceTask",
                task_type: "serviceTask",
                task_name: "Update case status to 'Case data collected'",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StartPostPredictionRuleSubprocess",
                task_type: "startEvent",
                task_name: "Start post-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "WaitForCaseDataTimerCatchEvent",
                task_type: "intermediateTimer",
                task_name: "Wait for case data",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CheckRouteToPredictExclusiveGateway",
                task_type: "exclusiveGateway",
                task_name: "Route to predict?",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "EndSendToCACSubprocess",
                task_type: "terminateEndEvent",
                task_name: "End send to CAC",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CheckCaseRequiredFieldsServiceTask",
                task_type: "serviceTask",
                task_name: "Check case required fields",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunDecorateRulesSubprocess",
                task_type: "callActivity",
                task_name: "Run decoration rules",
                incoming_transitions: "",
                task_iterations: 1,
                task_end_timestamp: "",
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "MockPyramidServiceTask",
                task_type: "serviceTask",
                task_name: "Mock prediction\n(no Pyramid)",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CollectCaseHL7ServiceTask",
                task_type: "serviceTask",
                task_name: "Collect case HL7",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunSystemPrePredictionRulesServiceTask",
                task_type: "businessRuleTask",
                task_name: "Run system pre-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunTenantDecorationRulesServiceTask",
                task_type: "businessRuleTask",
                task_name: "Run tenant Decoration rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "EndPrePredictionRulesSubprocess",
                task_type: "terminateEndEvent",
                task_name: "End pre-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "PredictionSubprocess",
                task_type: "callActivity",
                task_name: "Run prediction subprocess",
                incoming_transitions: "",
                task_iterations: 1,
                task_end_timestamp: "",
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "EndPostPredictionRuleSubprocess",
                task_type: "terminateEndEvent",
                task_name: "End post-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "GetPredictionConfigurationServiceTask",
                task_type: "serviceTask",
                task_name: "Get prediction configuration",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StoreArtifactsServiceTask",
                task_type: "serviceTask",
                task_name: "Store artifacts",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "SendHL7ToCACServiceTask",
                task_type: "serviceTask",
                task_name: "Send HL7 to CAC",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "PostPredictionRoutingSubprocess",
                task_type: "callActivity",
                task_name: "Run routing subprocess",
                incoming_transitions: "",
                task_iterations: 1,
                task_end_timestamp: "",
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunSystemPostPredictionRulesServiceTask",
                task_type: "businessRuleTask",
                task_name: "Run system post-prediction rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "PostPredictionEndEvent",
                task_type: "terminateEndEvent",
                task_name: "Post-prediction process end",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RetrieveProcessInstanceServiceTask",
                task_type: "serviceTask",
                task_name: "Retrieve process instance",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RetrieveCaseConfigurationServiceTask",
                task_type: "serviceTask",
                task_name: "Retrieve case configuration",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "StartLiveRadiologyProcess",
                task_type: "conditionalStartEvent",
                task_name: "Start radiology process",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RunSystemDecorationRulesServiceTask",
                task_type: "businessRuleTask",
                task_name: "Run system decoration rules",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "RetrieveSourceSystemArtifactServiceTask",
                task_type: "serviceTask",
                task_name: "Retrieve source system artifacts",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "CollectCaseDataServiceTask",
                task_type: "serviceTask",
                task_name: "Collect case data",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            },
            {
                task_id: "SelectedRoutesInclusiveGateway",
                task_type: "inclusiveGateway",
                task_name: "Selected routes?",
                incoming_transitions: "",
                task_end_timestamp: "",
                task_iterations: 1,
                task_inputs: {},
                task_outputs: {},
                outgoing_transitions: ""
            }
        ]
    },
    rule_evaluation_results: [
        {
            dmn_decision_version: 1,
            dmn_decision_name: "Pre-Prediction Rules",
            dmn_decision_key: "pre_prediction_rules",
            dmn_decision_version_tag: 1,
            bpmn_activity_id: "EndPrePredictionRulesSubprocess",
            inputs: {
                case_data: {
                    stop_light_indicator: "green",
                    result_status: "F",
                    point_of_care: null,
                    date_of_service: "2019-08-10",
                    exam_code: "MR.MS.LOEXX"
                },
                config_data: {
                    end_date: "2999-12-31",
                    provider_exclusions: null,
                    go_live_date: "2020-01-01",
                    max_age_in_days: "180",
                    exam_code_exclusions: null,
                    point_of_care_exclusions: null
                }
            },
            matched_rules: []
        },
        {
            dmn_decision_version: 1,
            dmn_decision_name: "Decorate StopLight Rules",
            dmn_decision_key: "decorate_stoplight",
            dmn_decision_version_tag: 1,
            bpmn_activity_id: "RunSystemDecorationRulesServiceTask",
            inputs: {
                case_data: {
                    stop_light_indicator: "green",
                    result_status: "F",
                    point_of_care: null,
                    date_of_service: "2019-08-10",
                    exam_code: "MR.MS.LOEXX"
                },
                config_data: {
                    end_date: "2999-12-31",
                    provider_exclusions: null,
                    go_live_date: "2020-01-01",
                    max_age_in_days: "180",
                    exam_code_exclusions: null,
                    point_of_care_exclusions: null
                }
            },
            matched_rules: [
                {
                    rule_id: "DecisionRule_03bbvfy",
                    condition: null,
                    outputs: {
                        decoration_category: null,
                        decoration_subcategory: null,
                        route_to_billing: null,
                        route_to_coder: null,
                        route_to_qa: null,
                        route_to_predict: null,
                        termination_indicator: null,
                        pre_predict_process_reason: null,
                        post_predict_process_reason: null
                    }
                },
                {
                    rule_id: "DecisionRule_1vltvj5",
                    condition: null,
                    outputs: {
                        decoration_category: null,
                        decoration_subcategory: null,
                        route_to_billing: null,
                        route_to_coder: null,
                        route_to_qa: null,
                        route_to_predict: null,
                        termination_indicator: null,
                        pre_predict_process_reason: null,
                        post_predict_process_reason: null
                    }
                }
            ]
        }
    ],
    decoration: null,
    custom_values: {}
};
var _notPrimaryCaseRun = __assign(__assign({}, _baseCaseRun), { primary_process_indicator: false, artifacts: [artifacts_1.addendum] });
var _addendumCaseRun = __assign(__assign({}, _baseCaseRun), { process_instance_id: 11, primary_process_indicator: false, run_type: "Addendum" });
var _baseCase = {
    id: 10,
    caseRuns: []
};
var _caseMaker = function (uiStatus, partialCaseRun) {
    if (partialCaseRun === void 0) { partialCaseRun = {}; }
    return __assign(__assign({}, _baseCase), { caseRuns: [
            __assign(__assign(__assign({}, _baseCaseRun), { prevent_billing_indicator: partialCaseRun.prevent_billing_indicator || false, prevent_send_to_coder_indicator: partialCaseRun.prevent_send_to_coder_indicator || false, case_status: uiStatus }), partialCaseRun)
        ] });
};
var baseAuto = {
    process_status: enums_1.ProcessStatus.DONE,
    rules: rules_and_reasons_1.Rules.AutomatedRule,
    post_prediction_process_reason: rules_and_reasons_1.Reasons.AutoPostProcess,
    automated_indicator: true
};
exports.automatedCase = _caseMaker(enums_1.uiStatus.AUTOMATED, baseAuto);
exports.autoTestingCase = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.TESTING }));
exports.failedClaimsEdits = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { claims_edit_enabled_indicator: null, claims_edit_indicator: false, claims_editor_issues: '{"77067":"[{"policy":"220.4","status":"Warning","message":"Per policy 220.4, HCPCS 77067 with diagnosis Z12.31 meets medical necessity but has additional restrictions based on age, gender and/or frequency; (see policy)"}]"}', claims_editor_payer_id: "015", claims_editor_payer_name: null }));
exports.passedClaimsEdits = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { claims_edit_enabled_indicator: null, claims_edit_indicator: true, claims_editor_issues: null, claims_editor_payer_id: "053", claims_editor_payer_name: null }));
exports.failedCCIEdits = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { cci_edit_indicator: false, cci_editor_issues: '{"74018":[{"status":"2","message":"Cannot be billed with 74019 unless documentation supports adding NCCI-appropriate modifier."}]}' }));
exports.passedCCIEdits = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { cci_edit_indicator: true, cci_editor_issues: null }));
exports.autoParallelCase = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.PARALLEL }));
exports.autoLiveCase = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.LIVE }));
exports.autoActiveCase = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.ACTIVE }));
exports.multipleCaseRuns = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.ACTIVE }));
exports.multipleCaseRuns.caseRuns.unshift(_notPrimaryCaseRun);
exports.caseWithAddendum = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.ACTIVE }));
exports.caseWithAddendum.caseRuns.unshift(_addendumCaseRun);
exports.multipleFinalAndAddenda = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, baseAuto), { phase: enums_1.CustomerPhase.ACTIVE }));
exports.multipleFinalAndAddenda.caseRuns.unshift(__assign(__assign({}, _notPrimaryCaseRun), { process_instance_id: 9 }));
exports.multipleFinalAndAddenda.caseRuns.unshift(_addendumCaseRun);
exports.multipleFinalAndAddenda.caseRuns.unshift(__assign(__assign({}, _addendumCaseRun), { process_instance_id: 12 }));
exports.noPrimaryProcess = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, _notPrimaryCaseRun), { phase: enums_1.CustomerPhase.ACTIVE }));
exports.automatedCasePreventBilling = _caseMaker(enums_1.uiStatus.AUTOMATED, {
    process_status: enums_1.ProcessStatus.DONE,
    automated_indicator: true,
    rules: rules_and_reasons_1.Rules.AutomatedRule,
    prevent_billing_indicator: true
});
exports.missingData = _caseMaker(enums_1.uiStatus.MANUAL, {
    process_status: enums_1.ProcessStatus.DONE,
    rules: rules_and_reasons_1.Rules.MissingData,
    post_prediction_process_reason: rules_and_reasons_1.Reasons.MissingData,
    automated_indicator: true
});
exports.nullRules = _caseMaker(enums_1.uiStatus.MANUAL, {
    process_status: enums_1.ProcessStatus.DONE,
    rules: null,
    post_prediction_process_reason: rules_and_reasons_1.Reasons.MissingData,
    automated_indicator: true
});
exports.radFootCase = _caseMaker(enums_1.uiStatus.AUTOMATED, {
    process_status: enums_1.ProcessStatus.DONE,
    rules: rules_and_reasons_1.Rules.ComplexRules,
    post_prediction_process_reason: rules_and_reasons_1.Reasons.AutoPostProcess,
    artifacts: [artifacts_1.radFoot]
});
exports.sentToCAC = _caseMaker(enums_1.uiStatus.MANUAL, {
    cci_edit_indicator: true,
    claims_edit_indicator: true,
    rules: rules_and_reasons_1.Rules.LowConfidenceRule,
    post_prediction_process_reason: rules_and_reasons_1.Reasons.LowConfidenceProcess,
    process_status: enums_1.ProcessStatus.PREDICTED
});
exports.noSchedulingDept = _caseMaker(enums_1.uiStatus.MANUAL, {
    rules: rules_and_reasons_1.Rules.NoSchedulingDeptRule,
    pre_prediction_process_reason: rules_and_reasons_1.Reasons.SendToCoder,
    post_prediction_process_reason: null,
    process_status: enums_1.ProcessStatus.AT_CODER
});
exports.failedCCI = _caseMaker(enums_1.uiStatus.MANUAL, {
    cci_edit_indicator: false,
    claims_edit_indicator: null,
    process_status: enums_1.ProcessStatus.PREDICTED
});
exports.failedClaims = _caseMaker(enums_1.uiStatus.MANUAL, {
    cci_edit_indicator: null,
    claims_edit_indicator: false,
    claims_edit_enabled_indicator: true,
    process_status: enums_1.ProcessStatus.PREDICTED
});
exports.sentToCACPreventSending = _caseMaker(enums_1.uiStatus.MANUAL, {
    process_status: enums_1.ProcessStatus.PREDICTED,
    prevent_send_to_coder_indicator: true
});
exports.dormantUnautomatedCase = _caseMaker(enums_1.uiStatus.DORMANT, {
    process_status: enums_1.ProcessStatus.PREDICTED
});
exports.dormantAutomatedCase = _caseMaker(enums_1.uiStatus.DORMANT, {
    process_status: enums_1.ProcessStatus.DONE,
    automated_indicator: true
});
exports.atCoder = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: enums_1.ProcessStatus.AT_CODER
});
exports.dataCollected = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: enums_1.ProcessStatus.DATA_COLLECTED
});
exports.updatedManual = _caseMaker(enums_1.uiStatus.UPDATED_MANUAL, {
    process_status: enums_1.ProcessStatus.MANUAL
});
exports.didNotCode = _caseMaker(enums_1.uiStatus.CANCELLED, {
    process_status: enums_1.ProcessStatus.DONE
});
exports.cancelled = _caseMaker(enums_1.uiStatus.CANCELLED, {
    process_status: enums_1.ProcessStatus.DONE
});
exports.inProgressCase = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: enums_1.ProcessStatus.MANUAL
});
exports.inProgressWaitingCase = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: enums_1.ProcessStatus.AT_CODER
});
exports.waitingForData = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: enums_1.ProcessStatus.WAITING_FOR_DATA
});
exports.predictionInProgress = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: enums_1.ProcessStatus.PREDICTION_IN_PROGRESS
});
// SEEN IN THE WILD!
exports.nullProcessStatus = _caseMaker(enums_1.uiStatus.IN_PROGRESS, {
    process_status: null
});
exports.noProcessInstances = _caseMaker(enums_1.uiStatus.DORMANT, {
    process: {
        tasks: []
    }
});
exports.errorCase = _caseMaker(enums_1.uiStatus.CANCELLED, {
    process_status: enums_1.ProcessStatus.ERROR
});
// more complex cases
var manualAndAutomatedProcess = [
    __assign(__assign({}, _baseCaseRun), { process_instance_id: 3, process_status: enums_1.ProcessStatus.DONE, run_type: enums_1.ProcessRunType.MANUAL }),
    __assign(__assign({}, _baseCaseRun), { process_instance_id: 4, process_status: enums_1.ProcessStatus.DONE, run_type: enums_1.ProcessRunType.PREDICTION })
];
exports.manualAndAutomated = _caseMaker(enums_1.uiStatus.DORMANT, {
    process: {
        tasks: []
    }
});
var onlyManualProcess = [
    __assign(__assign({}, _baseCaseRun), { process_instance_id: 3, process_status: enums_1.ProcessStatus.DONE, run_type: enums_1.ProcessRunType.MANUAL }),
    __assign(__assign({}, _baseCaseRun), { process_instance_id: 4, process_status: enums_1.ProcessStatus.DONE, run_type: enums_1.ProcessRunType.MANUAL })
];
exports.onlyManual = _caseMaker(enums_1.uiStatus.DORMANT, {
    process: {
        tasks: []
    }
});
var radFoot3 = __assign(__assign({}, artifacts_1.radFoot2), { procedures: {
        confidence: 0.9900000000000001,
        uuid: "c7cc349b-b62a-4951-8da8-3568876e0c51",
        automate: true,
        evidence: [],
        codes: [
            {
                procedure_code: "72250",
                type: "cpt",
                units: 1.0,
                automate: true,
                uuid: "c7cc349b-b62a-4951-8da8-3568876e0c50",
                evidence: [
                    {
                        feature: {
                            uuid: "ccb5dc26-210e-4bdc-afae-20758be67410",
                            type: "ngram",
                            ngram: "No endoleaks are detected",
                            slop: 1,
                            in_order: true,
                            display: true,
                            field: "raw_body",
                            spans: [
                                {
                                    start: 812,
                                    end: 837,
                                    content: "No endoleaks are detected",
                                    uuid: "cce97bb3-9d74-4d1f-b0e3-095kk583ddc3",
                                    document_id: 234325,
                                    level: "ngram"
                                },
                                {
                                    start: 812,
                                    end: 837,
                                    content: "No endoleaks are detected",
                                    uuid: "cce97bb3-9d74-4d1f-b0e3-095ll583ddc3",
                                    document_id: 234325,
                                    level: "sentence"
                                }
                            ]
                        },
                        type: "Ngram",
                        score: 1.8524357683146013
                    }
                ],
                modifiers: {
                    confidence: 0.9900000000000001,
                    automate: true,
                    evidence: [],
                    codes: [
                        {
                            uuid: "c7cc349b-b62a-4951-8da8-3568876e0c49",
                            confidence: 0.9900000000000001,
                            modifier_code: "26"
                        }
                    ]
                },
                diagnoses: {
                    confidence: 0.9900000000000001,
                    automate: true,
                    type: "icd10",
                    evidence: [],
                    codes: [artifacts_1.R60]
                }
            }
        ]
    }, artifact_id: "TXN0025" });
var multipleAutomatedProcess = __assign(__assign({}, _baseCaseRun.process), { process_instance_id: 3, process_status: enums_1.ProcessStatus.DONE, run_type: enums_1.ProcessRunType.PREDICTION });
exports.multipleAutomated = _caseMaker(enums_1.uiStatus.AUTOMATED, {
    process: multipleAutomatedProcess,
    artifacts: [artifacts_1.radFoot2, radFoot3, artifacts_1.withSourceSystem]
});
exports.duplicateArtifacts = _caseMaker(enums_1.uiStatus.AUTOMATED, {
    artifacts: artifacts_1.duplicates
});
exports.noDisplayedCodes = _caseMaker(enums_1.uiStatus.AUTOMATED, {
    artifacts: [
        {
            type: "PREDICTION",
            artifact_id: "10",
            identifier: "10",
            procedures: {
                evidence: [],
                automate: true,
                uuid: "c7cc349b-333-4951-8da8-3568876e0c47",
                codes: [
                    {
                        procedure_code: "73030",
                        units: 1.0,
                        automate: true,
                        uuid: "c7cc349b-333-4951-8da8-3568876e0c42",
                        evidence: [
                            {
                                feature: {
                                    uuid: "ccb5dc26-333-4bdc-afae-20758be67410",
                                    type: "prior",
                                    ngram: "No endoleaks are detected",
                                    slop: 1,
                                    in_order: true,
                                    display: true,
                                    field: "not_a_field_we_know_about",
                                    spans: [
                                        {
                                            start: 812,
                                            end: 837,
                                            content: "No endoleaks are detected",
                                            uuid: "cce97bb3-333-4d1f-b0e3-095mm583ddc3",
                                            document_id: 234325,
                                            level: "ngram"
                                        },
                                        {
                                            start: 812,
                                            end: 837,
                                            content: "No endoleaks are detected",
                                            uuid: "cce97bb3-333-4d1f-b0e3-095nn583ddc3",
                                            document_id: 234325,
                                            level: "sentence"
                                        }
                                    ]
                                },
                                type: "Ngram",
                                score: 1.8524357683146013
                            }
                        ],
                        modifiers: {
                            evidence: [],
                            codes: []
                        },
                        diagnoses: {
                            evidence: [],
                            codes: []
                        }
                    }
                ]
            },
            modifiers: {
                evidence: [],
                codes: []
            },
            diagnoses: {
                evidence: [],
                codes: []
            }
        }
    ]
});
exports.basicCaseRunV2 = __assign(__assign({}, _baseCaseRun), { invoices: [], version: "version1", case_json_id: "12345", service_tenant_name: "Service Tenant Name", service_tenant_code: "Service Tenant Code", provider_tenant_name: "Provider Tenant Name", provider_tenant_code: "Provider Tenant Code", specimen_sources: [], scenarios: [], grouper: "grouper", transactions: [], decorators: [], case_event_id: 1233, send_to_coder_orchestrator: true, coder_orchestrator_destination: "coder", feedback_loop_enabled: false, tenant_uid: "a1234", admitting_provider_name: "Admitting Provider Name", admitting_provider: {
        number: "5677",
        issuer: "issuer",
        type: "type"
    } });
exports.radV4 = {
    id: 31447,
    caseRuns: [
        {
            version: "2.0",
            case_json_id: "RAD-35204",
            case_id: 31447,
            process_instance_id: 35204,
            process_instance_guid: "09e02bc0-bcae-48b9-8642-38cce867a81b",
            case_encounter_id: 25854,
            case_uid: null,
            caserun_uid: null,
            encounter_uid: null,
            process_uid: null,
            parent_process_instance_id: null,
            parent_caserun_id: null,
            parent_case_id: null,
            primary_case_indicator: null,
            case_status: "Manual",
            process_status: "Expired",
            primary_process_indicator: true,
            process_case_indicator: null,
            chargeable_indicator: null,
            run_type: "prediction",
            source_type: "HL7",
            service_line: "Radiology",
            tenant_code: "MGH",
            tenant_name: "Massachusetts General Hospital",
            tenant_timezone: "America/New_York",
            health_system_code: "PHS",
            service_tenant_name: null,
            service_tenant_code: null,
            provider_tenant_name: null,
            provider_tenant_code: null,
            note_unavailable_reason: null,
            patient_id: 225973,
            patient_name: "CDTRobel, CDTSandie",
            date_of_birth: "1940-09-03",
            patient_age: null,
            patient_gender: "F",
            patient_identifier: {
                number: "378875265887",
                issuer: "EPIC",
                type: "PMRN"
            },
            visit_number: {
                number: "959777324895",
                issuer: "EPIC",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "CDT158714920736",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: null,
            reason_for_visit: "* Parkinson's disease",
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "959777324895-2024-06-20-997988",
                issuer: "CMX",
                type: "ENCOUNTER_NUMBER"
            },
            point_of_care: "MGH_MGPMRIAR",
            place_of_service: "MGHASSEMROW",
            order_control: "RE",
            order_number: {
                number: "2bfc68e309874a11acc816",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_placer_number: {
                number: "2bfc68e309874a11acc816",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_filler_number: {
                number: "711cbe5a4bdfa9d93b9cf36e91",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            ordering_provider_name: "BALABAN, DENIS",
            ordering_provider_type: null,
            ordering_provider_specialty: "",
            ordering_provider_number: {
                number: "DB168",
                issuer: "PHS",
                type: "PRN"
            },
            primary_clinical_identifier: {
                number: "711cbe5a4bdfa9d93b9cf36e91",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            division: "MGHASSEMROW",
            exam_code: "MR.NE.BRAIN-",
            exam_description: "MRI BRAIN WITHOUT CONTRAST",
            body_region: "Head and Neck",
            procedure_type: "Magnetic Resonance",
            procedure_type_category: "MR",
            work_queue_name: "MR HEAD/NECK",
            date_of_service: "2024-06-20",
            datetime_of_service: "2024-06-20 06:56:23 EDT",
            exam_date: null,
            exam_datetime: null,
            relevant_clinical_info: null,
            sending_facility: null,
            placer_field_2: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            result_status: "F",
            scheduling_department: "MGP IMG MR AR",
            scheduling_department_code: "MGH_MGPMRIAR",
            em_category: null,
            resource_name: "MGH MR1AR",
            resource_code: "MR1AR",
            admission_datetime: "2022-09-15 06:26:52 EDT",
            discharge_datetime: null,
            attending_provider_specialty: null,
            attending_provider_name: null,
            attending_provider_number: null,
            billing_location: "MGHASSEMROW",
            billing_area: null,
            billing_provider_specialty: "",
            billing_provider_name: "KAMALIAN, SHAHMIR",
            billing_provider_type: null,
            billing_provider_number: {
                number: "12260",
                issuer: "NWH",
                type: "PRN"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            billing_patient_identifier: null,
            referring_provider_specialty: null,
            referring_provider_name: "BALABAN, DENIS",
            referring_provider_type: null,
            referring_provider_number: {
                number: "DB168",
                issuer: "PHS",
                type: "PRN"
            },
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_type: null,
            performing_provider_number: null,
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: null,
            hl7_insurance_plan_id: null,
            hl7_insurance_plan_text: null,
            hl7_insurance_payer_id: null,
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_name: null,
            tenant_insurance_payer_number: null,
            tenant_medicare_contractor: null,
            cmx_insurance_plan_text: "UNKNOWN PAYER (System Applied)",
            cmx_insurance_payer_id: "172",
            cmx_mapped_payer_number: null,
            cmx_payer_group_name_property_name: null,
            cmx_payer_category_property_name: null,
            claims_edit_enabled_indicator: null,
            medicare_jurisdiction: null,
            medicare_contractor: null,
            requires_medicaid_cci_edits_indicator: false,
            requires_cms_cci_edits_indicator: false,
            requires_ncd_edits_indicator: false,
            requires_lcd_edits_indicator: false,
            requires_commercial_edits_indicator: false,
            requires_mln_edits_indicator: false,
            requires_article_edits_indicator: false,
            requires_cms_manual_edits_indicator: false,
            requires_transmittal_manual_edits_indicator: false,
            specimen_sources: [],
            scenario: null,
            scenarios: [],
            case_type: null,
            specialty: null,
            grouper: null,
            custom_values: {
                routing: null,
                cds_g_code: null,
                read_department: "MGH IMG XR OP WAC2",
                read_department_ADT: "MGH_IMGXRW4",
                cds_modifier: null
            },
            mappings: [
                {
                    name: "exam_code",
                    value: "MR.NE.BRAIN-",
                    mapped_values: [
                        {
                            name: "customer_automation_decision",
                            value: "ELIGIBLE",
                            values: []
                        },
                        {
                            name: "procedure_type",
                            value: "Magnetic Resonance",
                            values: []
                        },
                        {
                            name: "procedure_type_category",
                            value: "MR",
                            values: []
                        },
                        {
                            name: "work_queue_name",
                            value: "MR HEAD/NECK",
                            values: []
                        }
                    ]
                }
            ],
            parts: [],
            invoices: [
                {
                    type: "CLINICAL",
                    guid: "132376",
                    billing_location: "MGHASSEMROW",
                    division: "MGHASSEMROW",
                    filler_number: {
                        number: "711cbe5a4bdfa9d93b9cf36e91",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    billing_provider_name: "KAMALIAN, SHAHMIR",
                    billing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    ordering_provider_name: "BALABAN, DENIS",
                    ordering_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    referring_provider_name: "BALABAN, DENIS",
                    referring_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    performing_provider_name: "KAMALIAN, SHAHMIR",
                    performing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    transactions: [
                        {
                            guid: "141092",
                            sequence_number: 1,
                            type: "PB",
                            date_of_service: "2024-06-20",
                            datetime_of_service: "2024-06-20 06:56:23 EDT",
                            transaction_type: "CG",
                            transaction_id: 141092,
                            department_code: "MGH_MGPMRIAR",
                            place_of_service: "MGHASSEMROW",
                            billing_use_indicator: false,
                            procedure: {
                                procedure_id: 141092,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "70551",
                                type: null,
                                units: 1,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1,
                                evidence: [],
                                modifier_codes: null,
                                used: true
                            }
                        }
                    ]
                },
                {
                    type: "ASSEMBLED",
                    guid: "132378",
                    billing_location: "MGHASSEMROW",
                    division: "MGHASSEMROW",
                    filler_number: {
                        number: "711cbe5a4bdfa9d93b9cf36e91",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    billing_provider_name: "KAMALIAN, SHAHMIR",
                    billing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    ordering_provider_name: "BALABAN, DENIS",
                    ordering_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    referring_provider_name: "BALABAN, DENIS",
                    referring_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    performing_provider_name: "KAMALIAN, SHAHMIR",
                    performing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    transactions: [
                        {
                            guid: "141094",
                            sequence_number: 1,
                            type: "PB",
                            date_of_service: "2024-06-20",
                            datetime_of_service: "2024-06-20 06:56:23 EDT",
                            transaction_type: "CG",
                            transaction_id: 141094,
                            department_code: "MGH_MGPMRIAR",
                            place_of_service: "MGHASSEMROW",
                            billing_use_indicator: false,
                            procedure: {
                                procedure_id: 141094,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "70551",
                                type: null,
                                units: 1,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: true,
                                confidence: 1,
                                evidence: [],
                                modifier_codes: null,
                                used: true
                            },
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "G20",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.6464351214294463,
                                    sequence_number: 1,
                                    type: null,
                                    evidence: [],
                                    used: true
                                }
                            ]
                        }
                    ]
                },
                {
                    type: "SUBMITTED",
                    guid: "132378",
                    billing_location: "MGHASSEMROW",
                    division: "MGHASSEMROW",
                    filler_number: {
                        number: "711cbe5a4bdfa9d93b9cf36e91",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    billing_provider_name: "KAMALIAN, SHAHMIR",
                    billing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    ordering_provider_name: "BALABAN, DENIS",
                    ordering_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    referring_provider_name: "BALABAN, DENIS",
                    referring_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    performing_provider_name: "KAMALIAN, SHAHMIR",
                    performing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    transactions: [
                        {
                            guid: "141094",
                            sequence_number: 1,
                            type: "PB",
                            date_of_service: "2024-06-20",
                            datetime_of_service: "2024-06-20 06:56:23 EDT",
                            transaction_type: "CG",
                            transaction_id: 141094,
                            department_code: "MGH_MGPMRIAR",
                            place_of_service: "MGHASSEMROW",
                            billing_use_indicator: false,
                            procedure: {
                                procedure_id: 141094,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "70551",
                                type: null,
                                units: 1,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: true,
                                confidence: 1,
                                evidence: [],
                                modifier_codes: null,
                                used: true
                            },
                            diagnoses: [
                                {
                                    diagnosis_uid: null,
                                    diagnosis_code: "G20",
                                    evidence_source_uid: null,
                                    automate: false,
                                    confidence: 0.6464351214294463,
                                    sequence_number: 1,
                                    type: null,
                                    evidence: [],
                                    used: true
                                }
                            ]
                        }
                    ]
                },
                {
                    type: "MAPPED",
                    guid: "132375",
                    billing_location: "MGHASSEMROW",
                    division: "MGHASSEMROW",
                    filler_number: {
                        number: "711cbe5a4bdfa9d93b9cf36e91",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    billing_provider_name: "KAMALIAN, SHAHMIR",
                    billing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    ordering_provider_name: "BALABAN, DENIS",
                    ordering_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    referring_provider_name: "BALABAN, DENIS",
                    referring_provider_number: {
                        number: "DB168",
                        issuer: "PHS",
                        type: "PRN"
                    },
                    performing_provider_name: "KAMALIAN, SHAHMIR",
                    performing_provider_number: {
                        number: "12260",
                        issuer: "NWH",
                        type: "PRN"
                    },
                    transactions: [
                        {
                            guid: "141091",
                            sequence_number: 1,
                            type: "PB",
                            date_of_service: "2024-06-20",
                            datetime_of_service: "2024-06-20 06:56:23 EDT",
                            transaction_type: "CG",
                            transaction_id: 141091,
                            department_code: "MGH_MGPMRIAR",
                            place_of_service: "MGHASSEMROW",
                            billing_use_indicator: false,
                            procedure: {
                                procedure_id: 141091,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "70551",
                                type: null,
                                units: 1,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1,
                                evidence: [],
                                modifier_codes: null,
                                used: true
                            }
                        }
                    ]
                }
            ],
            artifacts: [
                {
                    artifact_id: 132377,
                    type: "PREDICTION",
                    identifier: "35204",
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 141093,
                                procedure_uid: null,
                                evidence_source_uid: null,
                                procedure_name: null,
                                procedure_code: "70551",
                                type: null,
                                units: 1,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: 0.9618708656705054,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.0013467088948786454,
                                        feature: {
                                            slop: 2,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "brain without",
                                            type: "ngram",
                                            spans: []
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.0013467088948786454,
                                        feature: {
                                            slop: 0,
                                            field: "exam_type",
                                            in_order: true,
                                            ngram: "mri brain",
                                            type: "ngram",
                                            spans: []
                                        }
                                    }
                                ],
                                modifier_codes: null,
                                used: true,
                                modifiers: {
                                    confidence: 0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0,
                                    primary_code_confidence: 0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                }
                            }
                        ],
                        confidence: 0.9618708656705054
                    },
                    modifiers: {
                        confidence: 0,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.6464351214294463,
                        primary_code_confidence: 0.7808187566345133,
                        primary_predicted_code: "G20",
                        automate: true,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_uid: null,
                                diagnosis_code: "G20",
                                evidence_source_uid: null,
                                automate: false,
                                confidence: 0.6464351214294463,
                                sequence_number: 1,
                                type: null,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.11837121212121215,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "parkinson",
                                            type: "ngram",
                                            spans: []
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.11837121212121215,
                                        feature: {
                                            slop: 1,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "parkinson diseas",
                                            type: "ngram",
                                            spans: []
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.11837121212121215,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "parkinson",
                                            type: "ngram",
                                            spans: []
                                        }
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.11837121212121215,
                                        feature: {
                                            slop: 1,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "parkinson diseas",
                                            type: "ngram",
                                            spans: []
                                        }
                                    }
                                ],
                                used: true
                            }
                        ]
                    }
                }
            ],
            transactions: [],
            notes: [
                {
                    document_id: 203690,
                    description: null,
                    content: "MRI BRAIN WITHOUT CONTRAST\n  \n TECHNIQUE:\n Multi-sequence, multi-planar MRI of the brain was performed without intravenous contrast.\n  \n COMPARISON: None.\n  \n FINDINGS:\n  \n Brain Parenchyma: \n  \n No evidence of acute infarct, mass lesion, or hemorrhage.\n  \n There are scattered periventricular, subcortical, and pontine white matter T2/FLAIR-hyperintensities, a nonspecific finding but most likely on the basis of chronic microvascular ischemic changes. \n  \n Ventricular System and Extra-Axial Spaces: \n  \n Mildly widened sulci with proportionate enlargement of the ventricles suggest age-related generalized parenchymal volume loss.\n  \n No evidence of midline shift or hydrocephalus.\n  \n Extracranial Structures: \n  \n Arterial flow voids in the skull base are present.\n  \n There are bilateral lens implants. The orbits and globes are otherwise unremarkable.\n  \n IMPRESSION:\n  \n No evidence of acute infarct, mass lesion, or hemorrhage.\n  \n \n Interpreted by:\n Shahmir C Kamalian, MD\n \n Signed by:\n Shahmir C Kamalian, MD\n 9/15/22\n \n Final result\n",
                    content_raw: null,
                    filename: null,
                    type: "RAW",
                    activity_datetime: null,
                    availibility_status: null,
                    completion_status: null,
                    confidentiality_status: null,
                    content_presentation: null,
                    edit_datetime: null,
                    encoding: null,
                    mime_type: null,
                    origination_datetime: null,
                    id: null
                }
            ],
            case_created_datetime: "2024-06-21 01:44:50 EDT",
            process_instance_created_datetime: "2024-06-21 01:44:50 EDT",
            exclusion_datetime: null,
            prediction_start_datetime: "2024-06-21 01:46:13 EDT",
            added_to_batch_datetime: null,
            response_from_batch_datetime: null,
            prediction_end_datetime: "2024-06-21 02:33:00 EDT",
            automation_decision_datetime: "2024-06-21 02:34:41 EDT",
            send_to_coder_datetime: "2024-06-21 02:34:43 EDT",
            received_from_coder_datetime: null,
            send_to_billing_datetime: null,
            process_instance_completed_datetime: "2024-06-21 02:34:45 EDT",
            case_completed_datetime: "2024-06-21 02:34:45 EDT",
            claims_edit_indicator: false,
            cci_edit_indicator: true,
            claims_editor_payer_id: null,
            claims_editor_payer_name: null,
            claims_editor_issues: '{"G20":"Deleted Code"}',
            cci_editor_issues: null,
            customer_automation_decision: "ELIGIBLE",
            post_manual_charges: true,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: false,
            automated_indicator: false,
            route_to_predict: true,
            route_to_billing: false,
            route_to_qa: false,
            route_to_coder: true,
            route_to_claims_editor: null,
            pre_prediction_process_reason: null,
            post_prediction_process_reason: "Do Not Automate: Claims Edit",
            automate_decision_reason: "PREDICTION",
            termination_indicator: true,
            study_indicator: false,
            automation_eligible: true,
            can_automate: true,
            decoration: '{"Automate":["High Confidence"]}',
            decorators: [],
            hold_billing: false,
            hold_billing_reason: null,
            release_billing_reason: null,
            release_to_billing: false,
            release_to_coder: false,
            rules: '{"Automate":[{"decoration_category":"Automate","decoration_subcategory":"High Confidence","decoration_description":"Happy Path Prediction"}]}',
            rule_evaluation_results: [],
            process: null,
            phase: "LIVE",
            algorithm: "feynman",
            environment: "development",
            provenance: "CmxCaseBuilder",
            ml_function: "radiology-prediction",
            ml_version: "6.0.6",
            bpm_process_id: "60c71e36-2f91-11ef-8b84-260e23545492",
            prediction_job_id: "834",
            case_s3_uri: null,
            batch_s3_uri: null,
            prediction_s3_uri: null,
            external_id: "959e0beb1bae871f75",
            billing_export_id: null,
            cac_export_id: 25047,
            billing_group_id: 22427,
            case_event_id: null,
            export_group_id: null,
            resubmit_date: null,
            submitter_process: null,
            submitted_primary_clinical_identifier: null,
            message_ids: [],
            send_to_coder_orchestrator: false,
            coder_orchestrator_destination: null,
            feedback_loop_enabled: true,
            join_transactions_by_id: null,
            certification: null,
            results_report_status_change_datetime: null,
            last_entity_update: "2024-06-21 06:34:43 EDT",
            admission_type: null,
            admitting_provider: null,
            admitting_provider_name: null,
            alternate_visit_number: null,
            assigned_document_auth: null,
            assigned_document_auth_name: null,
            authentication_person: null,
            authentication_person_datetime: null,
            authentication_person_name: null,
            consulting_provider: null,
            consulting_provider_name: null,
            discharge_disposition: null,
            entity_id: null,
            hospital_account_record: null,
            hospital_service: null,
            insurance_company_name: null,
            message_code: null,
            message_datetime: null,
            message_trigger_event: null,
            note_specialty_designation: null,
            observation_id: null,
            observation_status: null,
            observation_subid: null,
            observation_text: null,
            originator: null,
            originator_name: null,
            placer_order_number_id: null,
            placer_order_number_namespace_id: null,
            primary_activity_provider_name: null,
            primary_activity_provider_number: null,
            rendering_provider_specialty: null,
            rendering_provider_name: "KAMALIAN, SHAHMIR",
            rendering_provider_type: null,
            rendering_provider_number: {
                number: "12260",
                issuer: "NWH",
                type: "PRN"
            },
            facts: {},
            parent_process_instance_uid: null,
            parent_caserun_uid: null,
            parent_case_uid: null,
            parent_case: null,
            child_case_list: [],
            ordering_diagnoses: []
        }
    ]
};
var radV4CaseRun = __assign({}, exports.radV4.caseRuns[0]);
var _notPrimaryCaseRunV4 = __assign(__assign({}, radV4CaseRun), { primary_process_indicator: false, artifacts: [artifacts_1.addendum] });
var _addendumCaseRunV4 = __assign(__assign({}, radV4CaseRun), { process_instance_id: 11, primary_process_indicator: false, run_type: "Addendum" });
exports.multipleFinalAndAddendaV4 = _caseMaker(enums_1.uiStatus.AUTOMATED, __assign(__assign({}, exports.radV4.caseRuns[0]), { phase: enums_1.CustomerPhase.ACTIVE }));
exports.multipleFinalAndAddendaV4.caseRuns.unshift(__assign(__assign({}, _notPrimaryCaseRunV4), { process_instance_id: 9 }));
exports.multipleFinalAndAddendaV4.caseRuns.unshift(_addendumCaseRunV4);
exports.multipleFinalAndAddendaV4.caseRuns.unshift(__assign(__assign({}, _addendumCaseRunV4), { process_instance_id: 12, invoices: radV4CaseRun.invoices.filter(function (invoice) { return invoice.type !== "SUBMITTED"; }) }));
//# sourceMappingURL=case.js.map